import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector, TypedUseSelectorHook } from 'react-redux';
import { stagingApiQueryErrorLogger } from './staging/stagingApiQueryErrorLogger';
import { stagingApi } from './staging/stagingSlice';
import { metadataApi } from './metadata/metadataSlice';
import reducers from './reducers';
import { userOrgApi } from './userOrg/userOrgSlice';
import { workflowApi } from './workflow/workflowSlice';
import { metadataApiQueryErrorLogger } from './metadata/metadataApiQueryErrorLogger';
import { workflowLWDsApi } from './workflowLWDs/workflowLWDsSlice';
import { workflowLWDApiQueryErrorLogger } from './workflowLWDs/workflowLWDsApiQueryErrorLogger';
import { transferApiQueryErrorLogger } from './transfer/transferApiQueryErrorLogger';
import { transferApi } from './transfer/transferSlice';
import { airflowApi } from './airflow/airflowSlice';
import { airflowApiQueryErrorLogger } from './airflow/airflowApiQueryErrorLogger';

const store = configureStore({
    reducer: reducers,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({ serializableCheck: false }).concat([
            userOrgApi.middleware,
            stagingApi.middleware,
            workflowApi.middleware,
            metadataApi.middleware,
            workflowLWDsApi.middleware,
            transferApi.middleware,
            airflowApi.middleware,
            workflowLWDApiQueryErrorLogger,
            stagingApiQueryErrorLogger,
            metadataApiQueryErrorLogger,
            transferApiQueryErrorLogger,
            airflowApiQueryErrorLogger,
        ]),
});

export type RootState = ReturnType<typeof reducers>;

export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

const useDispatch = () => useAppDispatch<AppDispatch>();
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { store, dispatch, useSelector, useDispatch };
